import { useResolvedCompanyCtx } from '@contexts/ResolvedCompanyContext/ResolvedCompanyProvider';
import * as React from 'react';
import { Box, GridRow } from '~ui/components/layout/Box';
import { Text } from '~ui/components/typography/Text/Text';
import { LanguagePicker } from '../../Routing/client';
import { HeaderNavigationButton } from './HeaderNavigationButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/**
 * Content of a HeaderScreen header,
 *  - **header navigation** to _home_ or _back_ on the left (or NO navigation if no value is provided),
 *  - **screen title** in the middle, defaults to company's primary name label,
 *  - **navigation** on the right OR just a language picker (if there should be any) if customer accounts are not enabled
 */
export var BaseHeaderContent = function BaseHeaderContent(_ref) {
  var title = _ref.title,
      padding = _ref.padding,
      alignSelf = _ref.alignSelf,
      navigateTo = _ref.navigateTo,
      navigationIcon = _ref.navigationIcon;

  var _useResolvedCompanyCt = useResolvedCompanyCtx(),
      hasMultipleLanguages = _useResolvedCompanyCt.hasMultipleLanguages;

  return /*#__PURE__*/_jsxs(GridRow, {
    alignSelf: alignSelf,
    padding: padding,
    gridTemplateColumns: "1fr auto 1fr",
    alignItems: "center",
    columnGap: "medium",
    children: [/*#__PURE__*/_jsx(Box, {
      justifySelf: "flex-start",
      children: /*#__PURE__*/_jsx(HeaderNavigationButton, {
        navigationIcon: navigationIcon,
        navigateTo: navigateTo
      })
    }), /*#__PURE__*/_jsx(Text, {
      fontStyle: "boldSemi",
      fontSize: "m18",
      children: title
    }), /*#__PURE__*/_jsx(Box, {
      justifySelf: "flex-end",
      children: hasMultipleLanguages && /*#__PURE__*/_jsx(LanguagePicker, {})
    })]
  });
};